import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import MicrosoftAzureIntegration from "../MicrosoftAzure/MicrosoftAzure";

const MicrosoftEntraIDIntegration = () => {
  const [searchParams] = useSearchParams();
  const [guideMode, setGuideMode] = useState(false);

  useEffect(() => {
    if (searchParams.has("viewonly")) {
      setGuideMode(true);
    }
  }, [searchParams]);
  return (
    <MicrosoftAzureIntegration
      integrationName="microsoft_entra_id"
      guideMode={guideMode}
    ></MicrosoftAzureIntegration>
  );
};

export default MicrosoftEntraIDIntegration;
